import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import { fbConfig } from "../../utils/DeploymentSettings";

// If we're not already initialized (coming from Flutter or the like), initialize
if (firebase.apps.length === 0) {
  firebase.initializeApp(fbConfig);
}

const firestore = firebase.firestore();
const functions = firebase.functions();
const auth = firebase.auth();
const storage = firebase.storage();
const analytics = firebase.analytics();

if (process.env?.REACT_APP_EMULATE === "true") {
  storage.useEmulator("localhost", 9199);
  firestore.useEmulator("localhost", 7337);
  functions.useEmulator("localhost", 5001);
  auth.useEmulator("http://localhost:9099");
}

export { firestore, auth, storage, analytics };
